export const environment = {
  production: false,
  keycloak: {
    url: 'https://i3identity.dev.intre.it/',
    clientId: 'i3skills-frontend',
  },
  apiUrl: '/api/v1',
};
